import script from "./addGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./addGroup.vue?vue&type=script&lang=ts&setup=true"

import "./addGroup.vue?vue&type=style&index=0&id=f90d06c0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f90d06c0"]])

export default __exports__